import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import { toRateNumber } from '~utils/rateFormatting';

interface InstallmentsFieldHelperProps {
  totalInstallments?: number | string;
}

// The backend applies an assignment while `total_installments` is 0, so blank and
// 0 both mean forever.
const InstallmentsFieldHelper = ({ totalInstallments }: InstallmentsFieldHelperProps) => {
  const isOngoing = (toRateNumber(totalInstallments) ?? 0) === 0;

  if (!isOngoing) {
    return null;
  }

  return (
    <Tooltip
      placement="top"
      title={t('administration.rates.automatic_add_ons.installments_ongoing_hint')}
    >
      <Typography
        component="button"
        data-test-id="installments-ongoing-label"
        type="button"
        variant="body2"
        sx={(theme) => ({
          backgroundColor: 'transparent',
          border: 'none',
          color: theme.brandV2.colors.treadGray2,
          cursor: 'help',
          display: 'block',
          fontFamily: 'inherit',
          fontSize: 11,
          p: 0,
          textDecoration: 'underline',
          textDecorationStyle: 'dotted',
          textUnderlineOffset: '2px',
        })}
      >
        {t('administration.rates.automatic_add_ons.installments_ongoing_label')}
      </Typography>
    </Tooltip>
  );
};

export default InstallmentsFieldHelper;
